import React, { useState } from 'react';
import { BaseConfigModal } from './BaseConfigModal';

interface GitHubConfigModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'add' | 'configure';
  integration?: {
    id: string;
    name: string;
    description: string;
    icon: string;
    connected: boolean;
  };
}

export const GitHubConfigModal: React.FC<GitHubConfigModalProps> = ({
  isOpen,
  onClose,
  type,
  integration
}) => {
  const [repoAccess, setRepoAccess] = useState('all');
  const [workspaceName, setWorkspaceName] = useState('');
  const [showDisconnectConfirm, setShowDisconnectConfirm] = useState(false);

  const handleSubmit = () => {
    // Handle form submission
    console.log('Form submitted:', { repoAccess, workspaceName });
    onClose();
  };

  const handleDisconnect = () => {
    // Handle disconnect action
    console.log('Disconnecting integration:', integration?.id);
    setShowDisconnectConfirm(false);
    onClose();
  };

  if (showDisconnectConfirm) {
    return (
      <BaseConfigModal
        isOpen={true}
        onClose={() => setShowDisconnectConfirm(false)}
        title="Disconnect Integration"
        icon={integration?.icon}
        onSubmit={handleDisconnect}
        submitText="Disconnect"
      >
        <p className="text-gray-400 mb-4">
          Are you sure you want to disconnect this integration? This action cannot be undone.
        </p>
      </BaseConfigModal>
    );
  }

  return (
    <BaseConfigModal
      isOpen={isOpen}
      onClose={onClose}
      title={type === 'add' ? 'Add GitHub Integration' : `Configure ${integration?.name}`}
      icon={integration?.icon}
      onSubmit={handleSubmit}
      submitText={type === 'add' ? 'Add Integration' : 'Save Changes'}
    >
      {type === 'add' && (
        <div className="space-y-2">
          <label className="text-sm text-gray-400">Workspace Name</label>
          <input
            type="text"
            value={workspaceName}
            onChange={(e) => setWorkspaceName(e.target.value)}
            className="w-full px-3 py-2 bg-gray-800/30 border border-gray-800 rounded-lg text-white placeholder-gray-500"
            placeholder="Enter workspace name"
          />
        </div>
      )}

      <div className="space-y-2">
        <label className="text-sm text-gray-400">Repository Access</label>
        <select
          value={repoAccess}
          onChange={(e) => setRepoAccess(e.target.value)}
          className="w-full px-3 py-2 bg-gray-800/30 border border-gray-800 rounded-lg text-white"
        >
          <option value="all">All repositories</option>
          <option value="selected">Selected repositories</option>
        </select>
      </div>

      <div className="space-y-2">
        <label className="text-sm text-gray-400">Webhook URL</label>
        <input
          type="text"
          className="w-full px-3 py-2 bg-gray-800/30 border border-gray-800 rounded-lg text-white"
          value="https://api.flawtrack.com/webhooks/github"
          readOnly
        />
      </div>

      {type === 'configure' && integration?.connected && (
        <div className="mt-6 pt-6 border-t border-gray-800">
          <button
            type="button"
            onClick={() => setShowDisconnectConfirm(true)}
            className="w-full px-4 py-2 bg-red-500/10 text-red-500 rounded-lg hover:bg-red-500/20 transition-colors"
          >
            Disconnect Integration
          </button>
        </div>
      )}
    </BaseConfigModal>
  );
};